"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertySubType = void 0;
/**
 * The PropertySubType object provides a set of constants for property sub types.
 *
 * These constants are based on the RESO PropertySubType dictionary.
 * See: {@link https://ddwiki.reso.org/display/DDW20/PropertySubType+Lookups}
 */
exports.PropertySubType = Object.freeze({
    /** The property is for farming and agricultural activities. */
    Agriculture: "Agriculture",
    /** A unit within a wholly owned structure of five or more units. This may not be used for Residential or Residential Income. For Residential, use Condo. For Income, use Residential Income. */
    Apartment: "Apartment",
    /** A place where you can tie up a boat or house boat. */
    BoatSlip: "Boat Slip",
    /** The property is designed for any type of business. */
    Business: "Business",
    /** A single-family residence that may have limited utilities. */
    Cabin: "Cabin",
    /** A unit within a structure where ownership is on a unit-by-unit basis. */
    Condominium: "Condominium",
    /** Co-ownership indicates that the property is owned by two or more parties in which each party has an equal ownership interest and obtains ownership at the same time. */
    CoOwnership: "Co-Ownership",
    /** A parking space (or spaces) that are owned and separate from a residence. */
    DeededParking: "Deeded Parking",
    /** A multifamily structure that has two independent units with a shared wall or ceiling/floor. */
    Duplex: "Duplex",
    /** A place where agricultural and similar activities take place, especially the growing of crops. */
    FarmSubType: "Farm",
    /** The property is designed for hotel or motel use. */
    HotelMotel: "Hotel/Motel",
    /** The property is designed for industrial use. */
    Industrial: "Industrial",
    /** A factory-built house that is transported to the lot. */
    ManufacturedHome: "Manufactured Home",
    /** A factory-built house that is transported to the lot and sold with the land. The property may or may not have a 433a certification. */
    ManufacturedOnLand: "Manufactured On Land",
    /** The property is designed to be used in more than one way (i.e., office and retail). */
    MixedUse: "Mixed Use",
    /** A factory-built house that is transported to the lot, retains axles and was built prior to June 15, 1976. */
    MobileHome: "Mobile Home",
    /** A permanent area for a group of mobile homes, usually with fixed utilities. */
    MobileHomePark: "Mobile Home Park",
    /** A structure or complex with five or more units that are individual dwellings. */
    MultiFamily: "Multi Family",
    /** The property is designed to be used as office space. */
    Office: "Office",
    /** A unit within a structure where ownership is based on a partial deed and rights to occupy a unit. */
    OwnYourOwn: "Own Your Own",
    /** A multifamily structure with four independent units with shared walls or ceilings/floors. */
    Quadruplex: "Quadruplex",
    /** A place where agricultural and similar activities take place, especially the raising of livestock. */
    Ranch: "Ranch",
    /** The property designed to be used as retail space. */
    Retail: "Retail",
    /** A stand-alone, detached residential building used as a single-dwelling unit with no shared walls and its own lot or land with no shared utilities with another dwelling unit. */
    SingleFamilyResidence: "Single Family Residence",
    /** A unit within a structure where ownership is based on a share of stock and rights to occupy a unit. */
    StockCooperative: "Stock Cooperative",
    /** Tenancy in Common (TIC) indicates that the property is owned by two or more parties in which each party has an ownership interest, which may or may not be equal, and may obtain ownership at different times. */
    TenancyInCommon: "Tenancy in Common",
    /** A form of property ownership where a property is held by a number of people, each with the right of possession for a specified time interval. */
    Timeshare: "Timeshare",
    /** A dwelling unit generally having two or more floors and attached to other similar units via party walls. */
    Townhouse: "Townhouse",
    /** A multifamily structure with three independent units with shared walls or ceilings/floors. */
    Triplex: "Triplex",
    /** Commercial land that has not been built upon or improved. */
    UnimprovedLand: "Unimproved Land",
    /** The property is designed to be used for warehousing. */
    Warehouse: "Warehouse",
    /** Residential Land is not explicitly listed in the RESO PropertySubType dictionary but is used by EXP Data Team. */
    ResidentialLand: "Residential Land",
    /** Commercial Land is not explicitly listed in the RESO PropertySubType dictionary but is used by EXP Data Team. */
    CommercialLand: "Commercial Land",
    /** Apartment/Condominium is a catch all for condos and is not explicitly listed in the RESO PropertySubType dictionary but is used by EXP Data Team. */
    Apartment_Condominium: "Apartment/Condominium",
    /** The property is designed for hotel or motel use. */
    HotelMotelESP: "Hotel-Motel",
    /** Other is a catch-all for any property type that is not explicitly listed in the RESO PropertyType dictionary */
    OtherSubType: "Other",
});
//# sourceMappingURL=property_sub_type.js.map